import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const infoHeadTitleList: any[] = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
  },
  {
    keyword: "title",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "転換予定日",
    keyword: "changeoverDueDate",
    type: "date",
    disabled: true,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLW050006_02,
  },
  {
    title: "施設名",
    keyword: "bFacilityName",
    type: "selectForm",
    disabled: true,
  },
  {
    title: "転換前施設種類",
    keyword: "bFacilityKind",
    type: "selectForm",
    disabled: true,
  },
  {
    title: "転換前施設所在地郵便番号",
    keyword: "bFacilityZipcode",
    type: "postcode",
    disabled: true,
  },
  {
    title: "転換前施設所在地",
    keyword: "bFacilityAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLW050006_03,
  },
  {
    title: "転換後施設名称",
    keyword: "aFacilityName",
    type: "selectForm",
    disabled: true,
  },
  {
    title: "転換後施設種類",
    keyword: "aFacilityKind",
    type: "selectForm",
    disabled: true,
  },
  {
    title: "転換後施設所在地郵便番号",
    keyword: "aFacilityZipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "転換後施設所在地",
    keyword: "aFacilityAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "備考",
    keyword: "remark",
    type: "textarea",
    disabled: true,
  },
];

const schema = {};

export { fakeTableList, schema, infoHeadTitleList };
